<template>
  <div>
    <div class="row">
      <div class="col-3 mb-3" v-for="post in requestData.data" :key="post.id">
        <div class="ratio ratio-1x1">
          <div class="overflow-hidden rounded">
            <a :href="postLink(post)">
              <img
                style="width: 100%; height: 100%; object-fit: cover"
                :src="`https://djceg34j53tq.cloudfront.net/${post.image}`"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="col-12 text-center" v-if="requestData.next_page_url">
        <button @click="loadMoreData" class="btn btn-link">
          {{ 'More' | translate }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['topicId'],
  data: () => ({
    requestData: {
      data: [],
    },
  }),
  mounted() {
    axios.post(`/json/community/gallery${this.urlSuffix}`).then(({ data }) => {
      this.requestData = { ...this.requestData, ...data.community_posts }
    })
  },
  methods: {
    loadMoreData() {
      axios
        .post(
          _.replace(
            this.requestData.next_page_url,
            'http:',
            window.location.protocol,
          ),
        )
        .then(({ data }) => {
          this.$set(
            this.requestData,
            'data',
            _.uniqBy(
              [...this.requestData.data, ...data.community_posts.data],
              'id',
            ),
          )
          this.$set(
            this.requestData,
            'next_page_url',
            data.community_posts.next_page_url,
          )
        })
    },
    postLink(post) {
      return `${window.location.protocol}//${window.location.host}/community/posts/${post.id}`
    },
  },
  computed: {
    urlSuffix() {
      if (this.topicId) {
        return `/${this.topicId}`
      }
      return ''
    },
  },
}
</script>

<style></style>
